import '../../styles/styles.css';
import React from 'react';
import StoryblokService from '../../lib/storyblok-service';

import Layout from '../../components/Layout';
import StoryblokComponents from '../../components/storyblok/StoryblokComponents.js';
import WorkHeader from '../../components/WorkHeader';
import getFeaturedProjects from '../../lib/getFeaturedProjects';
import useEditableContent from '../../lib/hooks/useEditableContent';

const StoryblokWorkItem = ({ project, featuredProjectsList, preview }) => {
  const content = useEditableContent(project?.content, preview);

  return (
    <React.Fragment>
      {project && (
        <Layout
          metaData={{ data: project }}
          featuredProjectsList={featuredProjectsList}
        >
          <article className="components page">
            <WorkHeader component={{ project: content }} />

            {content?.body.map((block) => (
              <StoryblokComponents block={block} key={block._uid} />
            ))}
          </article>
        </Layout>
      )}
    </React.Fragment>
  );
};

// This function gets called at build time on server-side.
export async function getStaticProps(ctx) {
  let { params, preview } = ctx;

  preview = preview || process.env.NODE_ENV !== 'production';

  const res = await StoryblokService.get(
    `cdn/stories/work/${params.storyblok}`,
    {
      version: preview ? 'draft' : 'published',
    }
  );

  const project = res.data.story;

  const featuredProjectsList = await getFeaturedProjects();

  return {
    props: { project, featuredProjectsList, preview },
    revalidate: 600,
  };
}

export async function getStaticPaths() {
  const res = await StoryblokService.get(`cdn/stories/`, {
    starts_with: 'work/',
  });
  const projects = res.data.stories;

  const paths = projects.map((project) => ({
    params: { storyblok: project.slug },
  }));

  return {
    paths,
    fallback: true,
  };
}

export default StoryblokWorkItem;
